import styles from './style.module.css';

import { useEffect, useState } from 'react';
import _ from 'underscore';

import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { Clipboard } from '../../components/Clipboard';

import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';

import iconFacebook from '../../assets/images/facebook.png';
import iconWhatsapp from '../../assets/images/whatsapp.png';
import iconInstagram from '../../assets/images/instagram.png';
import iconWeb from '../../assets/images/web.png';
import { HelmetComponent } from '../../components/Helmet';
interface IBenefit {
  benefitImage: string;
  benefitCode?: string;
  id: string;
  benefitDescription: string;
  benefitName: string;
  benefitLinkCompany: string;
  benefitLinkFacebook: string;
  benefitLinkInstagram: string;
  benefitLinkWhatsapp: string;
}

export function MyBenefits() {
  const [benefits, setBenefits] = useState<Array<IBenefit>>([]);

  const { client } = useAuth();

  useEffect(() => {
    getMyBenefits();
  }, []);

  const getMyBenefits = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getMyBenefits',
        userType: 'player',
        clientId: client.id,
      };

      const { data } = await api.post(`/search`, parameters);
      if (data.success) setBenefits(data.data);
    } catch (error) {
      console.log('error getMyBenefits', error);
    }
  };

  const redirectLink = (url: string) => {
    window.open(`${url}`, '_blank');
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Meus Benefícios'}
      />
      <div className="container">
        <div className="row">
          <div className="my-3">
            <ButtonBack title="Meus benefícios" />
          </div>
        </div>
        <div className="row">
          {_.map(benefits, (benefit) => (
            <div key={benefit.id} className="col-sm-12 col-md-4">
              <div className="mb-3 mb-md-0">
                <Card>
                  <div className={styles.benefitsImage}>
                    <img
                      src={benefit.benefitImage}
                      alt=""
                      className="rounded-4"
                    />
                    {benefit.benefitCode && (
                      <div className={styles.clipboard}>
                        <div className={styles.clipboardArea}>
                          <Clipboard shareUrl={benefit.benefitCode} />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mt-3">
                    <span className="fw-semibold fs-3">
                      {benefit.benefitName}
                    </span>
                    <p>{benefit.benefitDescription}</p>
                  </div>
                  <div className={`${styles.buttonsWrapper} gap-3`}>
                    <button
                      disabled={benefit.benefitLinkCompany === ''}
                      onClick={() => redirectLink(benefit.benefitLinkCompany)}
                      className={`${styles.btnShare} ${
                        benefit.benefitLinkCompany !== ''
                          ? styles.pointer
                          : styles.notAllowed
                      }`}
                    >
                      <img src={iconWeb} alt={iconWeb} />
                    </button>
                    <button
                      disabled={benefit.benefitLinkWhatsapp === ''}
                      onClick={() => redirectLink(benefit.benefitLinkWhatsapp)}
                      className={`${styles.btnShare} ${
                        benefit.benefitLinkWhatsapp !== ''
                          ? styles.pointer
                          : styles.notAllowed
                      }`}
                    >
                      <img src={iconWhatsapp} alt={iconWhatsapp} />
                    </button>
                    <button
                      disabled={benefit.benefitLinkFacebook === ''}
                      onClick={() => redirectLink(benefit.benefitLinkFacebook)}
                      className={`${styles.btnShare} ${
                        benefit.benefitLinkFacebook !== ''
                          ? styles.pointer
                          : styles.notAllowed
                      }`}
                    >
                      <img src={iconFacebook} alt={iconFacebook} />
                    </button>
                    <button
                      disabled={benefit.benefitLinkInstagram === ''}
                      onClick={() => redirectLink(benefit.benefitLinkInstagram)}
                      className={`${styles.btnShare} ${
                        benefit.benefitLinkInstagram !== ''
                          ? styles.pointer
                          : styles.notAllowed
                      }`}
                    >
                      <img src={iconInstagram} alt={iconInstagram} />
                    </button>
                  </div>
                </Card>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
